import { Controller } from '@hotwired/stimulus'
import { setFlash } from '../src/flash'
import { confirm } from '../src/turbo_confirm'

export default class extends Controller {
  static targets = ['list', 'item', 'template', 'count']
  static values = {
    replaceKey: { type: String, default: 'NEW_RECORD' },
    wrapperClass: { type: String, default: 'nested-fields' },
    max: Number,
    min: Number,
    count: Number
  }

  initialize () {
    this.element.nestedForm = this
  }

  connect () {
    this.updateCount()
  }

  findTemplate (name) {
    return name ? this.templateTargets.find(element => element.dataset.templateName == name) : this.templateTarget
  }

  authorize (event) {
    if (this.hasMaxValue && this.maxValue > 0 && this.countValue >= this.maxValue) {
      event.preventDefault()
      this.dispatch('unauthorized')
      setFlash('alert', `Maximum allowed: ${this.maxValue}`)
      return false
    } else {
      this.dispatch('authorized')
      return true
    }
  }

  addAssociation (event) {
    if (!this.authorize(event)) {
      return false
    }

    const template = typeof event === 'undefined' ? this.templateTarget : this.findTemplate(event.target.value)
    const tempId = Date.now() * Math.floor(Math.random() * 100)
    const content = template.innerHTML.replace(new RegExp(this.replaceKeyValue, 'g'), tempId)
    this.listTarget.insertAdjacentHTML('beforeend', content)

    const newElement = this.listTarget.lastElementChild
    newElement.dataset.tempId = tempId

    if (this.listTarget.sortableController) this.listTarget.sortableController.update()

    if (event && event.target.type == 'select-one') {
      event.target.querySelector('option').selected = true
    }

    this.updateCount()

    this.dispatch('added', { detail: { element: newElement, file: event?.detail?.file } })
    return newElement
  }

  async removeAssociation (event) {
    if (event.params.confirm) {
      if (!(await confirm(event.params.confirm))) {
        event.preventDefault()
        return false
      }
    }

    const wrapper = event.target.closest('.' + this.wrapperClassValue)

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == 'true') {
      wrapper.remove()

      // Existing records are hidden and flagged for deletion
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1
      wrapper.classList.add('!hidden', 'destroying')

      // Disable child required inputs so they don't trigger client side validation when hidden
      const required_child_inputs = wrapper.querySelectorAll('input:required, textarea:required, select:required')
      required_child_inputs.forEach(element => (element.disabled = true))

      // Disable validate.js validation
      const validated_child_inputs = wrapper.querySelectorAll('input, button, textarea, select')
      validated_child_inputs.forEach(element => delete element.dataset.validate)
    }

    this.dispatch('removed', { detail: { element: wrapper } })
    this.updateCount()
  }

  updateCount () {
    this.countValue = this.itemTargets.filter(item => !item.classList.contains('destroying')).length
  }

  countValueChanged () {
    if (this.hasCountTarget) {
      this.countTarget.value = this.countValue
    }
  }
}
